(function () {

    "use strict";

    console.log("⭐ Rating Widget Started");

    function renderRatingWidget() {

        if (!window.REVIEW_SUMMARY) {

            console.log("Waiting for REVIEW_SUMMARY...");

            setTimeout(renderRatingWidget, 500);

            return;

        }

        const placeholder = document.querySelector(
            "#trustshop-rating-placeholder"
        );

        if (!placeholder) {

            console.log("Waiting for Rating Placeholder...");

            setTimeout(renderRatingWidget, 500);

            return;

        }

        const summary = window.REVIEW_SUMMARY;

        const stars =
            "★".repeat(Math.floor(summary.average)) +
            "☆".repeat(5 - Math.floor(summary.average));

        placeholder.innerHTML = `

        <div class="ankur-rating-widget">

            <a href="#trustshop-review--container">

                <span class="ankur-rating-stars">
                    ${stars}
                </span>

                <span class="ankur-rating-average">
                    ${summary.average}
                </span>

                <span class="ankur-rating-count">
                    (${summary.total} Reviews)
                </span>

            </a>

        </div>

        `;

        console.log("✅ Rating Widget Rendered");

    }

    renderRatingWidget();

})();